import { useQuery } from '@tanstack/react-query';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { getSingleDeployment } from 'Services';
import { getCustomUserName, RQ_SINGLE_DEPLOYMENT } from 'Utils';

function useSingleDeployment(versionNum: number, users?: UsersHashmap) {
    const { templateRepositoryId } = useTemplateStore.getState().template;
    return useQuery(
        [RQ_SINGLE_DEPLOYMENT, templateRepositoryId],
        () => getSingleDeployment(templateRepositoryId!, versionNum),
        {
            enabled: !!(templateRepositoryId && templateRepositoryId > 0),
            select: (data) => ({
                ...data,
                /** Temp mock data to support a new feature: Scheduled Deplyment */
                status: 'Scheduled',
                scheduledAt: '1/17/2023, 11:00 AM',
                scheduledFor: '1/19/2023, 3:00 PM',
                scheduledBy: 'Appleseed, John',
                _formatted: {
                    createdBy: getCustomUserName(data.createdBy, users)
                }
            })
        }
    );
}

export default useSingleDeployment;
